<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><a href="javascript:;">My Courses</a></li>
                <li>{{course.nameEn}}</li>
            </ul>
            <h2>Course Detail</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<!-- Start Courses Details Area -->
<section class="courses-details-area pt-100 pb-70">
    <div class="container">
        <div class="courses-details-header">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="courses-title">
                        <h2>{{course.nameEn}}</h2>
                    </div>

                    <div class="courses-meta">
                        <ul>
                            <li>
                                <i class='bx bx-calendar'></i>
                                <span
                                    *ngIf="course.createdAt">{{course.createdAt['_seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</span>
                            </li>
                            <li *ngIf="currentLesson.pdfUrl != ''">
                                <i class='bx bxs-file-pdf'></i>
                                <a target="_blank" href="{{currentLesson.pdfUrl}}">PDF Download</a>
                            </li>
                            <li *ngIf="currentLesson.quiz">
                                
                                <a (click)="onShowQuiz()" class="btn" href="javascript:;">
                                    Take Quiz
                                </a>
                            </li>
                            
                        </ul>
                    </div>
                </div>

                
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">
                <div class="courses-details-image" style="margin-bottom:20px;">
                    <div [ngClass]="setVideoClasses(currentLesson)" class="text-center">
                        <app-video-player [isPause]="isPause" [videoUrl]="currentLesson.videoUrl" (onPlay)="onPlay($event)">
                        </app-video-player>
                    </div>
                </div>

                <a (click)="onHideShowDesc()" class="btn-hideshowdesc" href="javascript:;">
                    <span *ngIf="!hideDesc">
                        Hide Description
                    </span>

                    <span *ngIf="hideDesc">
                        Show Description
                    </span>
                </a>

                <div [ngClass]="setDescClasses()">
                    <h6 style="height:24px;">{{currentLesson.nameEn}}</h6>

                    <div style="padding-bottom:20px;" [innerHTML]="htmlContent"></div>

                    <!-- <app-comment-box [comments]="comments" [isPostingComment]="isPostingComment"
                        (onPostComment)="onPostComment($event)"></app-comment-box> -->
                </div>

            </div>

            <div class="col-lg-4">
                <div class="courses-sidebar-information">
                    <ul>
                        <li *ngFor="let lesson of lessons;let i = index" class="text-left" [attr.data-index]="i">
                            <a [ngClass]="setSeletedClass(lesson)" href="javascript:;"
                                (click)="chooseLesson(lesson)">{{i+1}} • {{lesson.nameEn}}</a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Courses Details Area -->

<app-quiz-dialog *ngIf="currentLesson" [lessonId]="currentLesson.id" [resultScore]="resultScore" [isLeftVisible]="!showScoreResult" [show]="showQuizDialog" [questions]="currentLesson.quiz" [instruction]="instruction" [audioUrl]="currentLesson.audioUrl" [audio]="currentLesson.audio" (onDismissCallback)="onDismissDialog()" (onSubmitCallBack)="onSubmitQuiz()" (onRetryQuizCallback)="onRetryQuiz()" (onShuffleQuizCallback)="onShuffleQuiz()" ></app-quiz-dialog>
